import { useEffect, useState } from "react";
import {
  getAllMasterLocationDetails,
  successDispatch,
} from "./ERPActions/erpActions";
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { BILLING_LOCATION_NAMES, ERP_HMS_MASTER_LOCATION_DETAILS, MASTER_LOCATION_DATA_LOCATION_KEY, PATIENT_VISIT_TYPE } from "../../core/constants/erpConstants";
import { useDispatch } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";
import FilterListIcon from "@mui/icons-material/FilterList";
import { helperServices } from "../../shared/helper";

export default function Filter(props) {
  const dispatch = useDispatch();

  const [masterLocationDetails, setMasterlocationDetails] = useState([]);
  const [userSelectedLocation, setUserSelectedLocation] = useState([]);
  const [clientLocationBillingMap, setClientLocationBillingMap] = useState({});
  const [visitType, setVisitType] = useState(props.visitType);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  // const [clientAnchors, setClientAnchors] = useState(null);

  const [clientAnchors, setClientAnchors] = useState({
      anchorEl: null,
      clientKey: null,
    });

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
    // setClientAnchors(null);
    setClientAnchors({
      anchorEl: null,
      clientKey: null,
    });
  };

  const onFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  // const handleSelectedLocation = (locationid, locationDetail) => {
  //   for(const selectedLoc of userSelectedLocation){
  //   }
  //   // userSelectedLocation
  //   setUserSelectedLocation([locationDetail]);
  //   props.selectedLocation([locationDetail]);
  //   handleClose();
  // };

  const handleSelectedLocation = (locationid, locationDetail) => {
    const isAll = locationDetail.locationKey === "all";

    console.log("handleSelectedLocation: ", locationDetail);

    // Check if clicked location is already selected
    const alreadySelected = userSelectedLocation.some(
      loc => loc.locationKey === locationDetail.locationKey
    );

    let updatedLocations;

    // Case 1: Clicking "ALL" → reset to only ALL
    if (isAll) {
      updatedLocations = [locationDetail];
    }
    // Case 2: "ALL" already selected & clicking something else → replace ALL
    else if (
      userSelectedLocation.some(loc => loc.locationKey === "all")
    ) {
      updatedLocations = [locationDetail];
    }
    // Case 3: Clicking an already-selected location → remove it (toggle off)
    else if (alreadySelected) {
      updatedLocations = userSelectedLocation.filter(
        loc => loc.locationKey !== locationDetail.locationKey
      );
    }
    // Case 4: Normal multi-select → add
    else {
      updatedLocations = [...userSelectedLocation, locationDetail];
    }

    if (updatedLocations.length === 0) {
      const allLoc = masterLocationDetails.find(
        loc => loc.locationKey === "all"
      );
      updatedLocations = allLoc ? [allLoc] : [];
    }

    setUserSelectedLocation(updatedLocations);
    props.selectedLocation(updatedLocations);
    handleClose();
  };



  const clearFilter = () => {
    const allLoc = masterLocationDetails.find((d) => d.locationKey === "all");
    if (allLoc) {
      setUserSelectedLocation([allLoc]);
      props.selectedLocation([allLoc]);
    }
  };

  const isLocationSelected = (locationKey) => {
    return userSelectedLocation.some(
      loc => loc.locationKey === locationKey
    );
  };


  const fetchMasterLocationDeatils = async (patientVisitType) => {
    const masterLocationList = await getAllMasterLocationDetails();
    if (!masterLocationList) return;

    const masterLocList = [];

    const allLoc = {
      displayName: "All",
      locationKey: "all",
      locationDetails: {
        erpLocationDetails: [
          {
            address: "Mangalore",
            locationid: [],
            name: "All",
            prefix: "All",
          },
        ],
      },
      servicesAllowed: [],
    };

    masterLocList.push(allLoc);

    console.log("visitType: ", patientVisitType);
    const currentUserRole = helperServices.getRole();
    const excludedLocationKeyByVisitType = !patientVisitType
      ? ""
      : patientVisitType.toLowerCase() === PATIENT_VISIT_TYPE.OUTPATIENT.toLowerCase()
        ? MASTER_LOCATION_DATA_LOCATION_KEY.IP_BILLING
        : MASTER_LOCATION_DATA_LOCATION_KEY.OP_BILLING;

        console.log("excludedLocationKeyByVisitType: ", excludedLocationKeyByVisitType);

    /* ---------------------------
       FILTER MASTER LOCATIONS
    ---------------------------- */
    masterLocationList.forEach((masterLoc) => {
      if (masterLoc.locationKey === excludedLocationKeyByVisitType) return;

      const locationData = masterLoc;
      const erpItem = locationData.locationDetails?.erpLocationDetails?.[0];

      if (!erpItem || !erpItem.hmsRolesAllowed?.includes(currentUserRole)) return;
      
      locationData.isBillableLocation = erpItem.isBillingLocation || false;
      // Collect ALL location IDs
      if(locationData.isBillableLocation){
        allLoc.locationDetails.erpLocationDetails[0].locationid.push(
          erpItem.locationid
        );
      }
      // Collect ALL services
      locationData.servicesAllowed?.forEach((service) => {
        if (!allLoc.servicesAllowed.includes(service)) {
          allLoc.servicesAllowed.push(service);
        }
      });

      masterLocList.push(locationData);
    });

    /* ---------------------------
       EXISTING LOCATION NAMES
    ---------------------------- */
    const existingClientListNames = masterLocList
      .filter((loc) => (loc.locationKey !== "all" && loc.locationDetails?.erpLocationDetails?.[0]?.clientsInBillableLocations))
      .map(
        (loc) => loc
      )
      .filter(
        (loc) => loc.displayName && loc.displayName.toUpperCase() !== "SANTHATHI"
      );

    const clientLocationsMap = {};

    // 1️⃣ Separate clients and locations correctly
    const clients = masterLocList.filter((loc) => {
      const erp = loc.locationDetails?.erpLocationDetails?.[0];
      return erp?.erpCustId != null; // client
    });

    const locations = masterLocList.filter((loc) => {
      const erp = loc.locationDetails?.erpLocationDetails?.[0];
      return erp?.erpCustId == null; // location
    });

    // 2️⃣ Build client → locations + ALL
    clients.forEach((client) => {
      const clientKey = client.locationKey;
      const clientName = client.displayName;
      const clientERPCustId = client.locationDetails?.erpLocationDetails?.[0]?.erpCustId;

      // matched locations
      const matchedLocations = locations.filter((location) => {
        const billableClients =
          location.locationDetails?.erpLocationDetails?.[0]
            ?.clientsInBillableLocations;

        return (
          Array.isArray(billableClients) &&
          billableClients.includes(clientKey)
        );
      });

      // prefixed locations
      const prefixedLocations = matchedLocations.map((location) => ({
        ...location,
        displayName: `${clientName} - ${location.displayName}`,
        locationKey: `${clientKey}_${location.locationKey}`,
        parentLocationKey: `${clientKey}`,
        clientERPCustId: clientERPCustId
      }));

      // collect all locationIds
      const allLocationIds = matchedLocations
        .map(
          (loc) =>
            loc.locationDetails?.erpLocationDetails?.[0]?.locationid
        )
        .filter(Boolean);

      // build ALL location (single object, not array)
      const allLocation = {
        ...client,
        displayName: `${clientName} - ALL`,
        locationKey: `${clientKey}_all`,
        parentLocationKey: `${clientKey}`,
        clientERPCustId: clientERPCustId,
        locationDetails: {
          erpLocationDetails: [
            {
              ...client.locationDetails?.erpLocationDetails?.[0],
              locationid: allLocationIds,
              parent: clientName,
            },
          ],
        },
      };

      clientLocationsMap[clientKey] = [allLocation, ...prefixedLocations];
      // setClientAnchors((prev) => ({ ...prev, [clientKey]: null }));
      // setClientAnchors(null);
      setClientAnchors({
        anchorEl: null,
        clientKey: null,
      });
      masterLocList.push(allLocation, ...prefixedLocations)
    });

    console.log("masterLocation:clientLocationsMap:", clientLocationsMap);
    console.log("masterLocList: ", masterLocList);

    // 3️⃣ Set state
    setClientLocationBillingMap(clientLocationsMap);

    /* ---------------------------
       DISPATCH & DEFAULT SELECT
    ---------------------------- */
    dispatch(successDispatch(ERP_HMS_MASTER_LOCATION_DETAILS, masterLocList));
    setMasterlocationDetails(masterLocList);

    if (props.currentLocation?.id) {
      handleSelectedLocation(
        props.currentLocation.id,
        props.currentLocation
      );
    } else {
      handleSelectedLocation(
        allLoc.locationDetails.erpLocationDetails[0].locationid,
        allLoc
      );
    }
  };


  useEffect(() => {
    console.log("visitType in filter : ", props.visitType, props);

    setVisitType(props.visitType);
    fetchMasterLocationDeatils(props.visitType);
  }, [props.visitType]);

  const visibleLocations = userSelectedLocation?.filter(
  (l) => !l.locationKey.endsWith("_all")
);


  return (
    <>
      <div className="d-flex justify-contents-center align-items-center">
        {userSelectedLocation && userSelectedLocation.length > 0 && (
         <div className="mr-3" style={{ marginRight: 9 }}>
        <Button className="shadow bg-white text-dark p-2 rounded" style={{ whiteSpace: "nowrap" }}>
        {(userSelectedLocation && userSelectedLocation.length > 0 && userSelectedLocation?.[0].locationKey !== "all") && 
        ( <ClearIcon style={{ marginLeft: 2 }} onClick={clearFilter} /> 
        )}
        {userSelectedLocation.length > 1 ? `${userSelectedLocation?.[0].displayName} & Others` : userSelectedLocation?.[0].displayName}
      </Button>
          </div>
        )}

        <Button
          className="shadow bg-white text-dark p-2 rounded"
          onClick={onFilterClick}
        >
          Filter <FilterListIcon />
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
            {masterLocationDetails.map((loc) => {
                  const locKey = loc.locationKey;
                  let excludedLocationKey = null;

                  if (visitType) {
                    excludedLocationKey =
                      visitType.toLowerCase() === PATIENT_VISIT_TYPE.OUTPATIENT.toLowerCase()
                        ? MASTER_LOCATION_DATA_LOCATION_KEY.IP_BILLING
                        : MASTER_LOCATION_DATA_LOCATION_KEY.OP_BILLING;
                  }
                  /* ---------------- CLIENT ---------------- */
                  if (clientLocationBillingMap[locKey]) {
                    // if (renderedClients.has(locKey)) return null;
                    // renderedClients.add(locKey);

                    const locations = clientLocationBillingMap[locKey];
                    // const anchor = clientAnchors[locKey];
                    const anchor = clientAnchors;

                    const clientDisplayName =
                      locations.find((l) =>
                        l.locationKey.endsWith("_all")
                      )?.displayName || loc.displayName;

                    return (
                      <div key={locKey}>
                         <MenuItem
                              onClick={(e) =>
                                setClientAnchors({
                                  anchorEl: e.currentTarget,
                                  clientKey: locKey,
                                })
                              }
                            >
                              ◀ {clientDisplayName.replace(" - ALL", "")}
                         </MenuItem>
                        <Menu
                            anchorEl={clientAnchors.anchorEl}
                            open={clientAnchors.clientKey === locKey}
                            onClose={() =>
                              setClientAnchors({ anchorEl: null, clientKey: null })
                            }
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",     // ⬅ attach to left edge
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",    // ⬅ expand leftwards
                            }}
                            PaperProps={{
                              style: {
                                marginRight: 8,       // spacing from parent menu
                                maxHeight: 300,
                                overflowY: "auto",
                              },
                            }}
                          >
                          {locations.map((child) => (
                            <MenuItem
                              key={child.locationKey}
                              selected={isLocationSelected(
                                child.locationKey
                              )}
                              onClick={() =>
                                handleSelectedLocation(
                                  child.locationKey,
                                  child
                                )
                              }
                            >
                              {isLocationSelected(child.locationKey) && (
                                <ListItemIcon>
                                  <CheckIcon fontSize="small" />
                                </ListItemIcon>
                              )}
                              <ListItemText
                                primary={child.displayName}
                              />
                            </MenuItem>
                          ))}
                        </Menu>
                      </div>
                    );
                  } else if (!clientLocationBillingMap[loc?.parentLocationKey] && (excludedLocationKey==null || (excludedLocationKey!=null && excludedLocationKey!=loc.locationKey)) && loc.isBillableLocation) {

                    {/* -------- Render non-client locations LAST -------- */ }
                    // {(!clientLocationBillingMap[loc?.parentLocationKey]) && (

                    return (
                      <div key={locKey}>
                        <MenuItem
                          key={loc.locationKey}
                          onClick={() =>
                            handleSelectedLocation(loc.locationKey, loc)
                          }
                        >
                          {isLocationSelected(loc.locationKey) && (
                            <ListItemIcon>
                              <CheckIcon fontSize="small" />
                            </ListItemIcon>
                          )}
                          <ListItemText primary={loc.displayName} />
                        </MenuItem>
                      </div>)
                    // )}
                  }
                })}
        </Menu>


      </div>
    </>
  );
}
